import validate from "validate.js";
export const isUrl = (url, options) => {
    const validation = validate({ website: url }, {
        website: {
            //check is required to use url validation if options is undefined
            url: options ? options : true,
        },
    });
    return validation === undefined;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXJsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3ZhbGlkYXRpb24vdXJsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sUUFBUSxNQUFNLGFBQWEsQ0FBQztBQVFuQyxNQUFNLENBQUMsTUFBTSxLQUFLLEdBQUcsQ0FBQyxHQUFXLEVBQUUsT0FBc0IsRUFBVyxFQUFFO0lBQ3BFLE1BQU0sVUFBVSxHQUFHLFFBQVEsQ0FDekIsRUFBRSxPQUFPLEVBQUUsR0FBRyxFQUFFLEVBQ2hCO1FBQ0UsT0FBTyxFQUFFO1lBQ1AsaUVBQWlFO1lBQ2pFLEdBQUcsRUFBRSxPQUFPLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsSUFBSTtTQUM5QjtLQUNGLENBQ0YsQ0FBQztJQUNGLE9BQU8sVUFBVSxLQUFLLFNBQVMsQ0FBQztBQUNsQyxDQUFDLENBQUMifQ==